import { render, staticRenderFns } from "./BrandVanHouten.vue?vue&type=template&id=7bcd6715&scoped=true&"
import script from "./BrandVanHouten.vue?vue&type=script&lang=js&"
export * from "./BrandVanHouten.vue?vue&type=script&lang=js&"
import style0 from "./BrandVanHouten.vue?vue&type=style&index=0&id=7bcd6715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd6715",
  null
  
)

export default component.exports